import React, {Component} from 'react';
import {NavLink, withRouter} from "react-router-dom";
import {withAlert} from 'react-alert';
import {addToCartFormSubmit, loadProduct} from "../common/Common";
import '../assets/css/Home.css';

class Product extends Component {
    constructor(props) {
        super(props);
        this.state = {product: null};
    }

    componentDidMount() {
        loadProduct(this.props.match.params.productId).then(data => {
            this.setState({product: data});
        }).catch(() => null);
    }

    render() {
        if (this.state.product) {
            let {product} = this.state;
            return (
                <div className="container category-list partner-list">
                    <h1 className="heading capital-text">
                        {product.name}
                    </h1>
                    <hr/>
                    <div className="d-flex bd-highlight w-100">
                        <div className="p-2 flex-fill bd-highlight">
                            <div id="carouselExampleIndicators" className="carousel slide" data-ride="carousel">
                                <ol className="carousel-indicators">
                                    {this.getCarouselIndicators()}
                                </ol>
                                <div className="carousel-inner">
                                    {this.getProductImageBody()}
                                </div>
                                <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button"
                                   data-slide="prev">
                                    <span className="carousel-control-prev-icon" aria-hidden="true"/>
                                    <span className="sr-only">Previous</span>
                                </a>
                                <a className="carousel-control-next" href="#carouselExampleIndicators" role="button"
                                   data-slide="next">
                                    <span className="carousel-control-next-icon" aria-hidden="true"/>
                                    <span className="sr-only">Next</span>
                                </a>
                            </div>
                        </div>
                        <div className="p-2 flex-fill bd-highlight">
                            Part Number: <strong>{product.part_number}</strong><br/><br/>
                            {product.description}<br/><br/>
                            Category:
                            <NavLink className="nav-link display-initial-link"
                                     to={"/category/" + product.category.name}>
                                {product.category.name}
                            </NavLink>
                            <br/><br/>
                            Store:
                            <NavLink className="nav-link display-initial-link text-capitalize"
                                     to={"/partner/" + product.partner.name}>
                                {product.partner.name}
                            </NavLink>
                            <hr/>
                            Price: <strong>Rs. {product.price}</strong><br/><br/>
                            Stock: <strong>{product.stock} items</strong><br/><br/>
                            <form className="d-flex bd-highlight w-100" onSubmit={this.formSubmit}>
                                <input className="form-control" type="text" id="id" defaultValue={product.id} hidden/>
                                <input className="form-control" type="text" id="name" defaultValue={product.name}
                                       hidden/>
                                <input className="form-control" type="number" id="stock" defaultValue={product.stock}
                                       hidden/>
                                <input className="form-control" type="number" id="price" defaultValue={product.price}
                                       hidden/>
                                <div className="p-2 flex-fill bd-highlight">
                                    <div className="form-inline">
                                        <label htmlFor="quantity" className="quantity-label">Quantity:</label>
                                        <input className="form-control" type="number" placeholder='Quantity*'
                                               id="quantity" min="1" max={product.stock} defaultValue="1" required/>
                                    </div>
                                </div>
                                <div className="p-2 flex-fill bd-highlight action-div">
                                    <button type="submit" className="btn blue-button login-button w-100"
                                            disabled={product.stock <= 0}>
                                        {product.stock > 0 ? "Add to Cart" : "Out of Stock"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    getProductImageBody = () => {
        let productImageBody = [];
        this.state.product.product_images.forEach((image, index) => {
            productImageBody.push(
                <div className={index === 0 ? "carousel-item active" : "carousel-item"} key={index}>
                    <img src={image.image_url} className="d-block w-100" alt={this.state.product.name}/>
                </div>
            );
        });
        return productImageBody
    }

    getCarouselIndicators = () => {
        let carouselIndicators = [];
        this.state.product.product_images.forEach((image, index) => {
            carouselIndicators.push(
                <li data-target="#carouselExampleIndicators" data-slide-to={index} key={index}/>
            );
        });
        return carouselIndicators;
    }

    formSubmit = (event) => {
        event.preventDefault();
        addToCartFormSubmit(event, this.props.alert);
    }
}

export default withAlert()(withRouter(Product));